import axios, {InternalAxiosRequestConfig} from 'axios'
import type { AxiosInstance, AxiosResponse } from 'axios'

const request: AxiosInstance = axios.create({
  baseURL: '/api',
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json'
  }
})

// 请求拦截器
request.interceptors.request.use(
  (config: InternalAxiosRequestConfig) => {
    // 直接从 localStorage 获取 token，避免在非组件上下文中调用 useUserStore
    const token = localStorage.getItem('token')
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

// 响应拦截器
request.interceptors.response.use(
  (response: AxiosResponse) => {
    return response.data
  },
  (error) => {
    if (error.response?.status === 401) {
      // 清除本地存储并跳转到登录页
      console.log('API 返回 401，清除登录信息并跳转到登录页')
      localStorage.removeItem('token')
      localStorage.removeItem('user')
      // 使用 router 跳转而不是 window.location，避免重复加载
      // 但这里不能直接使用 router，因为这是工具文件
      // 所以使用 window.location，但只在当前路径不是登录页时才跳转
      if (window.location.pathname !== '/login') {
        window.location.href = '/login'
      }
    }
    return Promise.reject(error)
  }
)

export default request 